<app-headline></app-headline>

<div *ngIf="i === serviceCount">
    <router-outlet></router-outlet>
</div>
<div *ngIf="i !== serviceCount" class="loadingGif">
    <app-loading-gif></app-loading-gif>
</div>
